import {getPromotionDropdownValues} from '@/services/PromotionsService/promotionProductSelection'
import {useQuery} from '@tanstack/react-query'

export const useGetProductAndBrandDropdown = (dropDownType = '') => {
  const query = useQuery({
    queryKey: ['productDropdown', dropDownType],
    queryFn: () => getPromotionDropdownValues(dropDownType),
    enabled: !!dropDownType,
    initialData: {data: []},
  })

  return query
}
